var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_15365)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "#F5D016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3265 18.6651C17.0388 18.3428 18.9763 15.8828 18.654 13.1705C18.3317 10.4582 15.8717 8.52068 13.1594 8.84298C10.4471 9.16529 8.50957 11.6253 8.83188 14.3376C9.15419 17.0499 11.6142 18.9874 14.3265 18.6651Z",
    fill: "#C21C05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0.253357C7.32705 0.253357 0.253357 7.32704 0.253357 16C0.253357 24.6729 7.32705 31.7466 16 31.7466C24.6729 31.7466 31.7466 24.6729 31.7466 16C31.7466 7.32704 24.6729 0.253357 16 0.253357ZM25.0845 25.0843C24.4994 25.6697 23.542 25.6697 22.957 25.0843L19.9629 22.0902C19.7411 21.8684 19.6941 21.5375 19.8203 21.2684L18.1145 19.5625C16.8987 20.4771 15.3867 21.0192 13.748 21.0192C9.73211 21.0192 6.47661 17.7636 6.47661 13.7479C6.47661 9.73211 9.73211 6.47654 13.748 6.47654C17.7639 6.47654 21.0194 9.73211 21.0194 13.7479C21.0194 15.3866 20.477 16.8986 19.5624 18.1145L21.2681 19.8202C21.5372 19.6941 21.8685 19.741 22.0902 19.9629L25.0844 22.9569C25.6695 23.5419 25.6695 24.4994 25.0844 25.0842L25.0845 25.0843Z",
    fill: "#C21C05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_15365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.4788470c1ab08b82e6f9f13c11777d7f.svg";
export { ForwardRef as ReactComponent };